import { PaletteMode, PaletteOptions, alpha } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { blue, grey, white, unityBlue, unityGrey } from './colors';

export const background = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['background'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          navigation: unityGrey[950],
          overlay: alpha(unityGrey[900], 0.7),
          default: white,
          paper: unityGrey[50],
          tooltip: unityGrey[900],
          popover: white,
          canvas: unityGrey[50],
          container: white,
          hover: unityGrey[50],
          selected: unityBlue[50],
        }
      : {
          navigation: unityGrey[900],
          overlay: alpha(unityGrey[800], 0.7),
          default: unityGrey[900],
          paper: unityGrey[800],
          tooltip: unityGrey[800],
          popover: unityGrey[800],
          canvas: unityGrey[950],
          container: unityGrey[900],
          hover: unityGrey[700],
          selected: unityBlue[700],
        };
  }

  return mode === 'light'
    ? {
        navigation: grey[850],
        overlay: alpha(grey[950], 0.7),
        default: white,
        paper: grey[50],
        tooltip: grey[900],
        popover: white,
        canvas: grey[50],
        container: white,
        hover: grey[50],
        selected: blue[50],
      }
    : {
        navigation: grey[850],
        overlay: alpha(grey[850], 0.7),
        default: grey[900],
        paper: grey[850],
        tooltip: grey[850],
        popover: grey[850],
        canvas: grey[950],
        container: grey[900],
        hover: grey[800],
        selected: blue[850],
      };
};
